import Vue from 'vue'

import cy from './cy'

Vue.directive('cy', cy)
